import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AdminsService } from '../services/admins/admins.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable()
export class AdminAuthInterceptor implements HttpInterceptor {

  constructor(
    private adminService: AdminsService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request and add the Authorization header if token exists
    const token = this.adminService['getToken'](); // using private method – better to make public or expose
    let authReq = req;
    if (token) {
      authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Token expired or invalid
          Swal.fire({
            icon: 'warning',
            title: 'Session expirée',
            text: 'Votre session a expiré. Veuillez vous reconnecter.',
            confirmButtonText: 'OK',
            allowOutsideClick: false
          }).then(() => {
            this.adminService.logout();
            this.router.navigate(['/login']);
          });
        }
        return throwError(() => error);
      })
    );
  }
}